import { render, staticRenderFns } from "./Valentine.vue?vue&type=template&id=60054f28&scoped=true&"
import script from "./Valentine.vue?vue&type=script&lang=js&"
export * from "./Valentine.vue?vue&type=script&lang=js&"
import style0 from "./Valentine.vue?vue&type=style&index=0&id=60054f28&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60054f28",
  null
  
)

export default component.exports